module.exports = __webpack_public_path__ + "static/home1-a91e59b91d732d8b7c9fcedbf5b20743.jpg";